import './App.css';
import { Home } from './pages'
import { Routes, Route } from "react-router-dom";
import * as React from "react";

function App() {

  return (
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/sc-event" element={<Home />} />
      </Routes>
  );
}

export default App;
